import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { selectGlobalsSettings } from '../../redux/globals/globals.selectors';
import { useSelector } from 'react-redux';

const GoogleAnalytics = ({ history, location, title }) => {
	const settings = useSelector(selectGlobalsSettings);
	const [isInitialized, setIsInitialized] = useState(false);

	const initGA = () => {
		if (isInitialized) return;
		if (typeof window !== 'undefined') {
			ReactGA.initialize('G-55TELN496H');
			ReactGA.ga('set', 'anonymizeIp', true);
			setIsInitialized(true);
		}
	};

	const sendPageView = () => {
		if (typeof window !== 'undefined') {
			ReactGA.ga('send', 'pageview', { page: location.pathname });
		}
	};

	useEffect(() => {
		console.log('init GA');
		initGA();
	}, []);

	useEffect(() => {
		console.log('send page');
		sendPageView();
	}, [history.location]);

	return null;
};

export default withRouter(GoogleAnalytics);
